/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcommerceOrderSyncResponseVo } from './EcommerceOrderSyncResponseVo';
import {
    EcommerceOrderSyncResponseVoFromJSON,
    EcommerceOrderSyncResponseVoFromJSONTyped,
    EcommerceOrderSyncResponseVoToJSON,
    EcommerceOrderSyncResponseVoToJSONTyped,
} from './EcommerceOrderSyncResponseVo';

/**
 * 
 * @export
 * @interface ResponseEcommerceOrderSyncResponseVo
 */
export interface ResponseEcommerceOrderSyncResponseVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseEcommerceOrderSyncResponseVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseEcommerceOrderSyncResponseVo
     */
    message?: string;
    /**
     * 
     * @type {EcommerceOrderSyncResponseVo}
     * @memberof ResponseEcommerceOrderSyncResponseVo
     */
    data?: EcommerceOrderSyncResponseVo;
}

/**
 * Check if a given object implements the ResponseEcommerceOrderSyncResponseVo interface.
 */
export function instanceOfResponseEcommerceOrderSyncResponseVo(value: object): value is ResponseEcommerceOrderSyncResponseVo {
    return true;
}

export function ResponseEcommerceOrderSyncResponseVoFromJSON(json: any): ResponseEcommerceOrderSyncResponseVo {
    return ResponseEcommerceOrderSyncResponseVoFromJSONTyped(json, false);
}

export function ResponseEcommerceOrderSyncResponseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseEcommerceOrderSyncResponseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : EcommerceOrderSyncResponseVoFromJSON(json['data']),
    };
}

export function ResponseEcommerceOrderSyncResponseVoToJSON(json: any): ResponseEcommerceOrderSyncResponseVo {
    return ResponseEcommerceOrderSyncResponseVoToJSONTyped(json, false);
}

export function ResponseEcommerceOrderSyncResponseVoToJSONTyped(value?: ResponseEcommerceOrderSyncResponseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': EcommerceOrderSyncResponseVoToJSON(value['data']),
    };
}

